import React, { useState } from 'react';
import { Container, Paper, Typography, TextField, Button } from '@mui/material';
import api from './AxiosConfig';
import Loading from "../Loading";

const AdminLoginPanel = ({ onLoginSuccess }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL;
    const [loading, setLoading] = useState(false);

    const handleLogin = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await api.post(`${baseUrl}/api/auth/login`, {
                username,
                password,
                role: 'ROLE_ADMIN'
            });
            onLoginSuccess(response.data.jwt);
            setUsername('');
            setPassword('');
        } catch (err) {
            alert('Nieprawidłowe dane logowania');
        } finally {
            setLoading(false)
        }
    };

    return (
        <Container maxWidth="xs">
            <Loading open={loading} />
            <Paper elevation={3} sx={{ padding: 3, marginTop: 5 }}>
                <Typography variant="h4" align="center" sx={{ marginBottom: 2 }}>
                    Logowanie Administratora
                </Typography>
                <form onSubmit={handleLogin}>
                    <TextField
                        label="Nazwa użytkownika"
                        variant="outlined"
                        fullWidth
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                        required
                        sx={{ marginBottom: 2 }}
                    />
                    <TextField
                        label="Hasło"
                        type="password"
                        variant="outlined"
                        fullWidth
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        sx={{ marginBottom: 2 }}
                    />
                    <Button type="submit" variant="contained" color="primary" fullWidth>
                        Zaloguj się
                    </Button>
                </form>
            </Paper>
        </Container>
    );
};

export default AdminLoginPanel;